export default {
  CHANGE_SWITCH_GRID(state) {
    state.switchGrid = !state.switchGrid;
  },

  CHANGE_GRID_SIZE(state, size) {
    state.gridSize = size;
  },

  // saving canvas items

}
